import { useState, FocusEvent, ChangeEvent, useCallback } from 'react';
import { PromotionCodeControlProps } from './PromotionCodeControl.interfaces';

export function usePromotionCodeControl({
  input,
  onValueChange,
  onControlBlur,
}: PromotionCodeControlProps) {
  const [focused, setFocused] = useState(false);

  const handleChange = useCallback(
    (event: ChangeEvent<HTMLInputElement>) => {
      input.onChange(event.target.value);

      if (onValueChange) {
        onValueChange(event.target.value, false, false, false);
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [input.onChange, onValueChange]
  );

  const handleBlur = useCallback(
    (event: FocusEvent<HTMLInputElement>) => {
      setFocused(false);

      input.onBlur(event.target.value.trim());

      if (onControlBlur) {
        onControlBlur(false, true, true);
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [input.onBlur, onControlBlur]
  );

  return {
    focused,
    handleChange,
    handleBlur,
  };
}
